
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Heart } from "lucide-react";
import { supabase } from "@/lib/supabase";

interface Recipe {
  id: string;
  title: string;
  user: {
    username: string;
  };
}

interface FavoriteRecipesCardProps {
  recipes: Recipe[];
}

export const FavoriteRecipesCard = ({ recipes }: FavoriteRecipesCardProps) => {
  const navigate = useNavigate();

  const handleRecipeClick = async (recipe: Recipe) => {
    const { data: normalizedUsername } = await supabase
      .rpc('normalize_username', { username: recipe.user.username });
    
    if (normalizedUsername) {
      navigate(`/${normalizedUsername}/${recipe.id}`);
    }
  };

  return (
    <Card className="p-6 space-y-4">
      <div className="flex items-center gap-2">
        <Heart className="w-5 h-5 text-red-500" />
        <h2 className="text-xl font-semibold">Favorite Recipes</h2>
      </div>
      <div className="space-y-3">
        {recipes.slice(0, 5).map((recipe) => (
          <div
            key={recipe.id}
            className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            onClick={() => handleRecipeClick(recipe)}
          >
            <span className="font-medium">{recipe.title}</span>
          </div>
        ))}
        {recipes.length === 0 && (
          <p className="text-gray-500 text-center py-4">
            No favorite recipes yet
          </p>
        )}
      </div>
    </Card>
  );
};
